import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  authApiUrl: string;
  localAuthApiUrl: string;
  resetPasswordApiUrl: string;
  localResetPasswordApiUrl: string;
}

const DEFAULT_APP_CONFIG: AppConfig = {
  authApiUrl: 'https://gateway.voyzant.com/v1/authuser/login',
  localAuthApiUrl: 'https://localhost:7095/v1/authuser/login',
  resetPasswordApiUrl: 'https://gateway.voyzant.com/v1/authuser/resetPassword',
  localResetPasswordApiUrl: 'https://localhost:7095/v1/authuser/resetPassword'
};

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly http = inject(HttpClient);
  private config: AppConfig = DEFAULT_APP_CONFIG;

  async load(): Promise<void> {
    try {
      const runtimeConfig = await firstValueFrom(
        this.http.get<Partial<AppConfig>>('assets/app-config.json')
      );
      this.config = {
        ...DEFAULT_APP_CONFIG,
        ...runtimeConfig
      };
    } catch (error) {
      console.warn('Failed to load app-config.json. Falling back to default config.', error);
      this.config = DEFAULT_APP_CONFIG;
    }
  }

  get authApiUrl(): string {
    if (typeof window !== 'undefined') {
      const hostName = window.location.hostname.toLowerCase();
      if (hostName === 'localhost' || hostName === '127.0.0.1') {
        return this.config.localAuthApiUrl;
      }
    }

    return this.config.authApiUrl;
  }

  get resetPasswordApiUrl(): string {
    if (typeof window !== 'undefined') {
      const hostName = window.location.hostname.toLowerCase();
      if (hostName === 'localhost' || hostName === '127.0.0.1') {
        return this.config.localResetPasswordApiUrl;
      }
    }

    return this.config.resetPasswordApiUrl;
  }
}
